import Vimeo from '@components/components/Vimeo/Vimeo';
import styles from '@components/components/Slider/GallerySlider/GallerySliderVideo.module.scss';
import {
  multiplySlidesIfNecessary,
  determinedAmountOfLoopedSlides,
} from '@components/components/Slider/GallerySlider/lib/loopMode';
import {
  Slider,
  SliderControl,
  Content,
  Heading,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';

const GallerySliderVideo = ({ headingLevel = 3, slides }) => {
  const [slidesToDisplay, loopedSlides] = useMemo(() => {
    const duplicatedSlides = multiplySlidesIfNecessary(slides);
    const amountOfLoopedSlides =
      determinedAmountOfLoopedSlides(duplicatedSlides);
    return [duplicatedSlides, amountOfLoopedSlides];
  }, [slides]);

  const sliderSettings = {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    loopedSlides,
    speed: 800,
  };

  return (
    <Slider {...sliderSettings} className={styles.slider}>
      <div className={styles.arrowContainer} data-no-slide="true">
        <SliderControl className={styles.arrow} direction="left" />
        <SliderControl className={styles.arrow} direction="right" />
      </div>
      {slidesToDisplay?.map(({ id, title, description, ...slide }) => (
        <Fragment key={id}>
          <Vimeo {...slide} />
          {title && (
            <Heading
              as={getHeadingTag(headingLevel)}
              className={styles.title}
              size="h3"
            >
              {title}
            </Heading>
          )}
          {description && (
            <Content className={styles.description} withParser>
              {description}
            </Content>
          )}
        </Fragment>
      ))}
    </Slider>
  );
};

GallerySliderVideo.propTypes = {
  headingLevel: PropTypes.number,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
      vimeoId: PropTypes.string.isRequired,
      videoSize: PropTypes.string.isRequired,
      onLoop: PropTypes.bool.isRequired,
      isAutoplay: PropTypes.bool.isRequired,
      hasControls: PropTypes.bool.isRequired,
      isMuted: PropTypes.bool.isRequired,
      noCookies: PropTypes.bool.isRequired,
    }),
  ),
};

GallerySliderVideo.defaultProps = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: null,
      description: null,
    }),
  ),
};

export default GallerySliderVideo;
